import React from 'react';
import Layout from './Layout';

const LeadDetail = () => {
  const lead = {
    name: 'Rahul Sharma',
    phone: '9876543210',
    email: 'rahul@email.com',
    requirement: '3kW Solar System',
    status: 'New',
    source: 'Website',
    date: '2026-06-25',
    message: 'I want to install solar at my home. Please provide quotation.',
    assigned: 'Unassigned'
  };

  return (
    <Layout>
      <div className="mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white">Lead Details</h1>
          <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">View and manage lead information</p>
        </div>
        <button className="px-5 py-2.5 bg-[#10B981] hover:bg-emerald-600 text-white font-bold rounded-xl shadow-lg shadow-emerald-500/20 transition-all text-sm">
          Generate Quotation
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white dark:bg-slate-900/50 rounded-2xl shadow-sm dark:shadow-xl border border-slate-200 dark:border-slate-800 p-6 transition-colors">
          <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-6">Lead Information</h3>
          <div className="space-y-6">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Name</p>
                <p className="font-bold text-slate-900 dark:text-white mt-1">{lead.name}</p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Phone</p>
                <p className="font-bold text-slate-900 dark:text-white mt-1">{lead.phone}</p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Email</p>
                <p className="font-bold text-slate-900 dark:text-white mt-1">{lead.email}</p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Source</p>
                <p className="font-bold text-slate-900 dark:text-white mt-1">{lead.source}</p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Date</p>
                <p className="font-bold text-slate-900 dark:text-white mt-1">{lead.date}</p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Status</p>
                <span className="inline-block mt-1 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-widest rounded-full bg-blue-500/10 text-blue-600 dark:text-blue-400 border border-blue-500/20">
                  {lead.status}
                </span>
              </div>
            </div>
            <div className="border-t border-slate-100 dark:border-slate-800/80 pt-4">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Requirement</p>
              <p className="font-bold text-slate-900 dark:text-white mt-1">{lead.requirement}</p>
            </div>
            <div className="border-t border-slate-100 dark:border-slate-800/80 pt-4">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500 mb-2">Message</p>
              <p className="text-slate-700 dark:text-slate-300 bg-slate-50 dark:bg-slate-800/50 p-4 rounded-xl text-sm border border-slate-200/60 dark:border-slate-700/50">
                {lead.message}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-slate-900/50 rounded-2xl shadow-sm dark:shadow-xl border border-slate-200 dark:border-slate-800 p-6 transition-colors">
          <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-6">Actions</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">Assign Employee</label>
              <select className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium">
                <option>Select Employee</option>
                <option>Rahul (Sales)</option>
                <option>Suresh (Sales)</option>
                <option>Amit (Manager)</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1.5">Update Status</label>
              <select className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-[#10B981] outline-none text-sm font-medium">
                <option>New</option>
                <option>In Progress</option>
                <option>Converted</option>
              </select>
            </div>
            <button className="w-full px-4 py-2.5 bg-[#10B981] hover:bg-emerald-600 text-white font-bold rounded-xl shadow-md shadow-emerald-500/10 transition-all text-sm mt-2">
              Save Changes
            </button>
            <button className="w-full px-4 py-2.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 font-bold rounded-xl transition-all text-sm border border-slate-200 dark:border-slate-700/60">
              Send Email
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LeadDetail;